const toNumberOrNull = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

const toSafeNumber = (value) => toNumberOrNull(value) ?? 0;
const PRICE_SCALE = 5;

const roundToScale = (value, scale = PRICE_SCALE) => {
  const factor = 10 ** scale;
  return Math.round((Number(value) + Number.EPSILON) * factor) / factor;
};

export const normalizeLinePricing = (line = {}, options = {}) => {
  const quantity = toSafeNumber(line.Quantity);
  const unitPrice = toSafeNumber(line.UnitPrice);
  const explicitDiscountPercent = toNumberOrNull(line.DiscountPercent) ?? toNumberOrNull((line.UnitDiscountValue / (unitPrice * quantity)) * 100);
  const explicitUnitDiscountValue = toNumberOrNull(line.UnitDiscountValue);
  const explicitDiscountValue = toNumberOrNull(line.DiscountValue);
  const useDiscountPercent = options.preferDiscountPercent || (
    explicitDiscountPercent !== null &&
    (explicitDiscountPercent !== 0 || (explicitUnitDiscountValue === null && explicitDiscountValue === null))
  );

  let unitDiscountValue = 0;

  if (useDiscountPercent) {
    unitDiscountValue = unitPrice * (explicitDiscountPercent / 100);
  } else if (explicitUnitDiscountValue !== null) {
    unitDiscountValue = explicitUnitDiscountValue;
  } else if (explicitDiscountValue !== null && quantity > 0) {
    unitDiscountValue = explicitDiscountValue / quantity;
  }

  const unitPriceAfterDiscount = roundToScale(unitPrice - unitDiscountValue);
  const normalizedUnitDiscountValue = roundToScale(unitPrice - unitPriceAfterDiscount);
  const discountValue = roundToScale(quantity * normalizedUnitDiscountValue);
  const discountPercent = useDiscountPercent
    ? explicitDiscountPercent
    : (unitPrice > 0 ? roundToScale((normalizedUnitDiscountValue / unitPrice) * 100) : 0);

  return {
    ...line,
    UnitPrice: unitPrice,
    UnitDiscountValue: normalizedUnitDiscountValue,
    UnitPriceAfterDiscount: unitPriceAfterDiscount,
    DiscountValue: discountValue,
    DiscountPercent: discountPercent,
    LineTotal: roundToScale(quantity * unitPriceAfterDiscount),
  };
};

export const normalizeLinePricingCollection = (lines = []) =>
  (lines ?? []).map((line) => normalizeLinePricing(line));